import { render } from "./Dropdown.vue?vue&type=template&id=47b1a9d4&scoped=true"
import script from "./Dropdown.vue?vue&type=script&lang=ts"
export * from "./Dropdown.vue?vue&type=script&lang=ts"

import "./Dropdown.vue?vue&type=style&index=0&id=47b1a9d4&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-47b1a9d4"

export default script